import { trackGTM } from 'services/Analytics/trackers';

import { History } from 'history';
import sendAnalyticsWithEventLabel from './sendAnalyticsWithEventLabel';

export const sendAnalyticForStartPage = (history: History, eventValue?: unknown) => {
    trackGTM({
        name: 'onboarding_start',
        data: {
            pageType: 'onboarding',
        },
    });
    sendAnalyticsWithEventLabel({
        url: history.location.pathname,
        eventValue: eventValue || 'start_now',
    });
};
